module.exports = __webpack_public_path__ + "static/img/brees-2009-slide-2.a5c2260.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-slide-2.jpg
// module id = K47h
// module chunks = 1